export default __webpack_public_path__ + "static/media/existinguser.fe5a9f90.svg";